import React from 'react';
import { Input, Label } from 'reactstrap';
import PropTypes from 'prop-types';

class JurisdictionDropDown extends React.Component {

    getItems = () => {
        let options = [];

        options = [<option key={0} value={''} disabled>{this.props.dropdownPlaceholder}</option>];
        this.props.jurisdictions.forEach((jurisdiction, index) => {
            options.push(<option key={`${this.props.name}` + index} value={jurisdiction.jurisdictionId}>{jurisdiction.fullName}</option>);
        });

        return options;
    }

    render() {
        var value = this.props.jurisdictions.filter(x => x.jurisdictionId === this.props.value) && this.props.value;
        return (
            <React.Fragment>
                <Label>Jurisdiction:</Label>
                <Input name='jurisdictionId' type='select' invalid={!value} onChange={this.props.onChange} value={value || ''}>
                    {this.getItems()}
                </Input>
            </React.Fragment>
        );
    }
}

JurisdictionDropDown.propTypes = {
    jurisdictions: PropTypes.array.isRequired,
    onChange: PropTypes.func.isRequired,
    value: PropTypes.number
}

export default JurisdictionDropDown;